import { render, staticRenderFns } from "./TemplateOptions.vue?vue&type=template&id=4d4460ac&"
import script from "./TemplateOptions.vue?vue&type=script&lang=js&"
export * from "./TemplateOptions.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports